/**
 *
 * RoleSettings
 *
 */

import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Card } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';
import { intlTags } from 'utils/intlFunctions.jsx';
import ExplicitRemoveModal from 'components/interaction/ExplicitRemoveModal/index.jsx';
import messages from './messages.js';
import InboxStatus, { INBOX_ARCHIVED } from '../InboxStatus.jsx';
import classInbox from '../../Groups/class-inbox.png';

function RoleSettings(props) {
  const { schoolRole, onChange } = props;
  const { conversations } = schoolRole;
  const [show, setShow] = useState(false);

  function handleChange(value) {
    if (value !== INBOX_ARCHIVED) {
      onChange(value);
      return;
    }
    setShow(true);
  }

  function handleArchive() {
    onChange(INBOX_ARCHIVED);
    setShow(false);
  }

  return (
    <Card>
      <Card.Header className="border-0">
        <h3><FormattedMessage {...messages.conversations} /></h3>
      </Card.Header>
      <Card.Body>
        <Card className="border">
          <Card.Body className="d-flex align-items-center">
            <img src={classInbox} alt="Class inbox" width="42" height="40" />
            <div className="flex-grow-1 mx-3">
              <h4 className="fs-6"><FormattedMessage {...messages.sharedInbox} /></h4>
              <FormattedMessage {...messages.sharedInboxItems} values={intlTags(['ul', 'li'])} />
            </div>
            <InboxStatus value={conversations.inbox} onChange={handleChange} />
          </Card.Body>
        </Card>
      </Card.Body>
      <ExplicitRemoveModal
        show={show}
        title={messages.confirmArchiveModalTitle}
        onHide={() => setShow(false)}
        onSubmit={handleArchive}
        confirmMessage={messages.doArchive}
      >
        <FormattedMessage {...messages.confirmArchiveModalIntro} />
        <FormattedMessage {...messages.archivedInboxRules} values={{ ...schoolRole, ...intlTags(['li', 'ul']) }} />
      </ExplicitRemoveModal>
    </Card>

  );
}

RoleSettings.propTypes = {
  onChange: PropTypes.func,
  schoolRole: PropTypes.object,
};

export default RoleSettings;
